import { createContext, useContext } from 'react'
import { CampaignFilterInput } from 'front-end/src/graphql/private/PrivateSchemaTypes'

export type EditCampaignFilterType = {
  editedFilter: CampaignFilterInput
  setEditedFilter: (filter: CampaignFilterInput) => void
}

export const EditCampaignFilterContext = createContext<EditCampaignFilterType>(
  null as any
)

export const useEditCampaignFilterContext = () =>
  useContext(EditCampaignFilterContext)
